import React from 'react';
import BigCalander from './BigCalander';

function Calander() {
  return (
    <div>
      <BigCalander />
    </div>
  );
}

export default Calander;
